// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__1re8K","icon":"style_icon__coFc0","heading":"style_heading__32R9a","subHeading":"style_subHeading__38aIA","flipIcon":"style_flipIcon__IGAEU"};